import StarsIcon from '../../assets/icons/StarsIcon.svg'
import { Container, ContentContainer, Title, ComingSoon, StarsImage } from './KYCLevelCover.styles'

export type KYCLevelCoverProps = {
    benefitsText: string
    comingSoonText: string
    starsAltText: string
}

const KYCLevelCover = ({ benefitsText, comingSoonText, starsAltText }: KYCLevelCoverProps) => {
    return (
        <Container>
            <ContentContainer>
                <Title>{benefitsText}</Title>
                <ComingSoon>{comingSoonText}</ComingSoon>
            </ContentContainer>
            <StarsImage src={StarsIcon as unknown as string} alt={starsAltText} />
        </Container>
    )
}

export default KYCLevelCover
